import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import { employeeLocation } from 'modules/locations/store/collections/locations'
import type Location from 'modules/locations/store/models/Location'

import { type Memberships } from './collections/memberships'
import { type Teams } from './collections/teams'
import { peopleLedByEmployee } from './peopleLedByEmployee'

export const peopleLedByEmployeeLocations = (
  teams: Teams,
  memberships: Memberships,
  employee: Employee,
  contractVersions: ContractVersions
) => {
  const locations = peopleLedByEmployee(teams, memberships, employee.id, contractVersions).reduce<
    Location[]
  >((result, follower) => {
    const location = employeeLocation(follower.id)

    if (location) {
      result.push(location)
    }

    return result
  }, [])

  if (locations.length) return locations

  const location = employeeLocation(employee.attributes.location_id)

  return location ? [location] : []
}
